import { createPivotTransformer } from './create-pivot-transformer';

const WATTS_PER_KW = 1000;
const WATTS_PER_MW = 1e6;

/** Pivot = W. */
export const POWER_PIVOT: Record<string, number> = {
  w: 1,
  kw: WATTS_PER_KW,
  mw: WATTS_PER_MW,
  gw: 1e9,
  tw: 1e12,
  hp: 745.7,
  'btu/h': 0.293071,
  tr: 3516.85,
  mw_demand: WATTS_PER_MW,
  kw_demand: WATTS_PER_KW,
};

export const transformPower = createPivotTransformer(POWER_PIVOT);
